import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { ElementoPrimarioConsolidadoService } from "../../services/ElementoPrimarioConsolidadoService";
import { SnackBarModule } from "../../modules/SnackBarModule";

export default {
    name: "GerenciarElementosPrimariosConsolidados",
    components: {
        Breadcrumb,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Elementos Primários',
                disabled: false,
                href: '#',
            },
            {
                text: 'Elementos Primários Consolidados',
                disabled: true
            }
        ],
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Ano', align: 'center', value: 'exercicio', width: '100px' },
            { text: 'Descrição', align: 'center', value: 'descricao', width: '300px' },
            { text: 'Gerência', align: 'center', value: 'gerencia', width: '120px' },
            { text: 'Valor Previsto', align: 'center', value: 'valor_total_previsto', width: '150px' },
            { text: 'Tipo', align: 'center', value: 'tipo_ep', width: '150px' },
        ],
        filters: {
            exercicioFilter: null,
            descricaoFilter: '',
            gerenciaFilter: null,
            tipoEpFilter: null,
        },
        items: [],
        itemSelected: [],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 30,
        loading: false,
        filterTimeout: null,
        exerciciosOptions: [],
        tiposEpOptions: [],
        gerenciasOptions: [],
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            return this.baseHeaders;
        },
        canVisualize() {
            return this.itemSelected.length === 1;
        }
    },
    created() {
        this.listarElementosPrimariosConsolidadosPaginado();
        this.carregarOpcoesFiltros();
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarElementosPrimariosConsolidadosPaginado();
        },
        itemSelected: {
            handler(newVal) {
                if (newVal.length > 1) {
                    this.itemSelected = [newVal[newVal.length - 1]];
                    SnackBarModule('Apenas um registro pode ser selecionado por vez para visualização.', 'warning');
                }
            },
            deep: true
        }
    },
    methods: {
        async listarElementosPrimariosConsolidadosPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ElementoPrimarioConsolidadoService.index(filter);

                if (typeof response !== 'string' && response && response.data) {
                    const items = response.data.data || [];
                    this.items = items.map((item, index) => ({
                        ...item,
                        uniqueId: `${item.tipo_ep || 'unknown'}_${item.id || index}_${Date.now()}`
                    }));
                    this.totalItems = response.data.total || 0;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os elementos primários consolidados.');
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os elementos primários consolidados:', error);
                this.items = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async carregarOpcoesFiltros() {
            try {
                const anosResponse = await ElementoPrimarioConsolidadoService.getAnosOptions();
                if (anosResponse && anosResponse.data) {
                    this.exerciciosOptions = anosResponse.data.map(ano => ({
                        text: String(ano),
                        value: ano
                    }));
                }

                const tiposEpResponse = await ElementoPrimarioConsolidadoService.getTiposEpOptions();
                if (tiposEpResponse && tiposEpResponse.data) {
                    this.tiposEpOptions = tiposEpResponse.data.map(tipo => ({
                        text: tipo,
                        value: tipo
                    }));
                }

                const gerenciasResponse = await ElementoPrimarioConsolidadoService.getGerenciasOptions();
                if (gerenciasResponse && gerenciasResponse.data) {
                    this.gerenciasOptions = gerenciasResponse.data.map(gerencia => ({
                        text: gerencia,
                        value: gerencia
                    }));
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar as opções dos filtros:', error);
            }
        },
        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.exercicioFilter !== null && this.filters.exercicioFilter !== '') {
                filter.append("exercicio", this.filters.exercicioFilter);
            }
            
            if (this.filters.descricaoFilter) {
                filter.append("descricao", this.filters.descricaoFilter);
            }
            
            if (this.filters.gerenciaFilter !== null && this.filters.gerenciaFilter !== '') {
                filter.append("gerencia", this.filters.gerenciaFilter);
            }
            
            if (this.filters.tipoEpFilter) {
                filter.append("tipo_ep", this.filters.tipoEpFilter);
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },
        
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarElementosPrimariosConsolidadosPaginado();
        },
        
        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text || '-';
            }
            return text.substring(0, maxLength) + '...';
        },

        formatCurrency(value) {
            if (!value && value !== 0) {
                return '-';
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        
        getTipoEpColor(tipo) {
            const colors = {
                'Genérico': '#9C27B0',
                'Emenda Estadual': '#2196F3',
                'Emenda Federal': '#4CAF50',
                'Convênio Federal': '#9C27B0'
            };
            return colors[tipo] || '#757575';
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        
        clearFilters() {
            this.filters = {
                exercicioFilter: null,
                descricaoFilter: '',
                gerenciaFilter: null,
                tipoEpFilter: null,
            };
            this.page = 1;
            this.listarElementosPrimariosConsolidadosPaginado();
        },
        
        handleFilterChange() {
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.listarElementosPrimariosConsolidadosPaginado();
            }, 300);
        },

        getRowClass() {
            return 'row-standard';
        },
        visualizarRegistro() {
            if (this.itemSelected.length === 0) {
                SnackBarModule('Selecione um registro para visualizar.', 'error');
                return;
            }
            
            if (this.itemSelected.length > 1) {
                SnackBarModule('Selecione apenas um registro para visualizar.', 'error');
                this.itemSelected = [this.itemSelected[0]];
                return;
            }
            
            const registro = this.itemSelected[0];
            const tipoEncoded = encodeURIComponent(registro.tipo_ep || 'unknown');
            this.$router.push({
                name: 'VisualizarElementoPrimarioConsolidado',
                params: { 
                    tipo: tipoEncoded,
                    id: registro.id || '0'
                }
            });
        }
    }
};

